import { render, staticRenderFns } from "./SidebarAddressDetail.vue?vue&type=template&id=1b379d2e&scoped=true&"
import script from "./SidebarAddressDetail.vue?vue&type=script&lang=js&"
export * from "./SidebarAddressDetail.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddressDetail.vue?vue&type=style&index=0&id=1b379d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b379d2e",
  null
  
)

export default component.exports